const TitleIVSAPNotice = "/Reports/TitleIVNoticeReport/GetTitleIVNoticeReport";

export const ReportUrl = {
    TitleIVSAPNotice
};